"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _SttBox = _interopRequireDefault(require("../../SttLayout/SttBox"));
var _header = _interopRequireDefault(require("../External/header"));
var _footer = _interopRequireDefault(require("../External/footer"));
var _excluded = ["children", "instancia", "basename"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    secaoCentral: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      flex: 1,
      margin: 'auto',
      width: '100%',
      '& a': {
        backgroundImage: 'none',
        background: 'none'
      },
      '& a:not(:disabled):hover': {
        backgroundImage: 'none !important',
        background: 'none !important'
      }
    },
    divExterna: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      background: function background(props) {
        if (props.configId === 'ebserh') {
          return '#fbfbfb';
        }
        switch (props.basename) {
          case 'ufpa':
            return 'linear-gradient(180deg,rgba(255, 255, 255, 0.10) 35%, rgba(196, 26, 27, 0.10) 67.5%, rgba(196, 26, 27, 0.10) 100%)';
          default:
            return 'linear-gradient(180deg, rgba(255, 255, 255, 0.10) 35%, rgba(132, 183, 219, 0.10) 67.5%, rgba(10, 111, 184, 0.10) 100%)';
        }
      }
    }
  };
});
var SttExterno = function SttExterno(_ref) {
  var children = _ref.children,
    instancia = _ref.instancia,
    basename = _ref.basename,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles({
    basename: basename,
    configId: global.gConfig.config_id
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.divExterna,
    style: props.style || {}
  }, /*#__PURE__*/_react["default"].createElement(_header["default"], {
    instancia: {
      logo: instancia.logo || instancia.logoHeader
    }
  }), /*#__PURE__*/_react["default"].createElement(_SttBox["default"], {
    className: classes.secaoCentral
  }, children), /*#__PURE__*/_react["default"].createElement(_footer["default"], {
    instancia: {
      logo: instancia.logo || instancia.logoFooter
    }
  }));
};
var _default = SttExterno;
exports["default"] = _default;